<template>
  <template v-if="isMobile">
    <p class="no-margin no-padding">{{ he.decode(mentionsPart1) }}</p>
    <p class="no-margin no-padding">{{ mentionsPart2 }}</p>
  </template>
  <template v-else
    >{{ he.decode(mentionsPart1) }} {{ mentionsPart2 }}
  </template>
</template>

<script setup>
// Vendor
import he from 'he';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';

/**
 * Constants
 */
const mentionsPart1 = '&#xA9; 2023 - présent. ESP Kobudo.';
const mentionsPart2 = 'Tous droits réservés.';

/**
 * Viewmodel
 */
const { isMobile } = useGlobalVM();
</script>
